import React, { useEffect, useState } from "react";
import classes from "./styles.module.scss";
import { getExamInfo } from "../../store/questions/apis";

// The three pages before the exam (Dashboard, Instructions, Exam details) share this step bar and the exam's
// details: duration, questions and marks come from the server (GET /exam/info), so each exam shows its own
// (BIPARD 90 minutes, BOR 150, an exam set to 210...) instead of figures written into the page.

const STEPS = [
    { en: "Language", hi: "भाषा" },
    { en: "Instructions", hi: "निर्देश" },
    { en: "Exam details", hi: "परीक्षा विवरण" },
];

export const ExamSteps = ({ current }) => (
    <ol className={classes.steps}>
        {STEPS.map((step, i) => (
            <li key={step.en} className={i < current ? classes.done : i === current ? classes.current : ""}>
                <span className={classes.dot}>{i < current ? "✓" : i + 1}</span>
                <span className={classes.label}>
                    {step.en}
                    <small>{step.hi}</small>
                </span>
            </li>
        ))}
        <li className={classes.exam_step}>
            <span className={classes.dot}>▶</span>
            <span className={classes.label}>
                Exam
                <small>परीक्षा</small>
            </span>
        </li>
    </ol>
);

// The current exam's details; null until they arrive (or if they cannot be fetched: the page then leaves
// the figures out rather than showing wrong ones)
export const useExamInfo = (examId) => {
    const [info, setInfo] = useState(null);
    useEffect(() => {
        if (!examId) return;
        let live = true;
        getExamInfo(examId).then((res) => {
            if (live && res?.status && res.data) setInfo(res.data);
        });
        return () => {
            live = false;
        };
    }, [examId]);
    return info;
};

// 90 -> "1 hour 30 minutes" / "1 घंटा 30 मिनट"
export const durationText = (minutes) => {
    const total = Math.max(0, Math.round(Number(minutes) || 0));
    const h = Math.floor(total / 60);
    const m = total % 60;
    const en = [h ? `${h} hour${h === 1 ? "" : "s"}` : "", m ? `${m} minute${m === 1 ? "" : "s"}` : ""].filter(Boolean).join(" ") || "0 minutes";
    const hi = [h ? `${h} ${h === 1 ? "घंटा" : "घंटे"}` : "", m ? `${m} मिनट` : ""].filter(Boolean).join(" ") || "0 मिनट";
    return { en, hi };
};

// "12:00:00" -> "12:00 PM"
export const clockText = (time) => {
    const [hh, mm] = String(time || "").split(":").map(Number);
    if (!Number.isFinite(hh) || !Number.isFinite(mm)) return "";
    const suffix = hh >= 12 ? "PM" : "AM";
    return `${((hh + 11) % 12) + 1}:${String(mm).padStart(2, "0")} ${suffix}`;
};

// "2026-10-18" -> "18/10/2026"
export const dateText = (date) => {
    const [y, mo, d] = String(date || "").slice(0, 10).split("-");
    return y && mo && d ? `${d}/${mo}/${y}` : "";
};
